<template>
  <el-dialog
    title="填案例"
    :visible.sync="innerVisible"
    width="900px"
    top="5vh"
    @opened="onOpened"
    @close="onClose"
  >
    <el-tabs v-model="activeTab" type="card">
      <!-- 模块1 申请案例 -->
      <el-tab-pane label="申请案例" name="apply">
        <el-form label-width="100px" size="small">
          <el-form-item label="申请感受">
            <el-input type="textarea" :rows="4" v-model="apply.feel" placeholder="请输入申请感受"></el-input>
          </el-form-item>
          <el-form-item label="合格通知书">
            <div :id="uploadId('apply-book')" class="uploader uploader-warning"></div>
            <a v-if="apply.book" :href="domain + apply.book" target="_blank" style="color:#409eff;margin-left:8px;">{{ apply.book }}</a>
          </el-form-item>
          <el-form-item label="通知书图片">
            <div :id="uploadId('apply-bookphoto')" class="uploader uploader-warning"></div>
            <img v-if="apply.bookPhoto" :src="domain + apply.bookPhoto" style="max-height:60px;margin-left:8px;" />
          </el-form-item>
          <el-form-item label="聊天截图">
            <case-image-upload v-model="fileLists.applyChat" :upload-id="uploadId('apply-chat')" :active="innerVisible" />
          </el-form-item>
        </el-form>
      </el-tab-pane>

      <!-- 模块2 文案案例 -->
      <el-tab-pane label="文案案例" name="copy">
        <el-form label-width="100px" size="small">
          <el-form-item label="文案内容">
            <el-input
              type="textarea"
              :rows="12"
              v-model="ext.copySpecialCase"
              placeholder="请填写文案相关内容（特殊情况、申请难点、服务感受等可写在一起）"
            ></el-input>
          </el-form-item>
          <el-form-item label="案例文件">
            <case-file-upload v-model="fileLists.copyCase" :upload-id="uploadId('copy-file')" :active="innerVisible" />
          </el-form-item>
          <el-form-item label="素材截图">
            <case-image-upload v-model="fileLists.copyMaterial" :upload-id="uploadId('copy-img')" :active="innerVisible" />
          </el-form-item>
        </el-form>
      </el-tab-pane>

      <!-- 模块3 课程签约 -->
      <el-tab-pane label="课程签约" name="course">
        <el-form label-width="100px" size="small">
          <el-form-item label="申请感受"><el-input type="textarea" :rows="4" v-model="ext.courseFeel" placeholder="请输入申请感受"></el-input></el-form-item>
          <el-form-item label="汇款截图">
            <case-image-upload v-model="fileLists.courseRemit" :upload-id="uploadId('course-remit')" :active="innerVisible" />
          </el-form-item>
          <el-form-item label="聊天截图">
            <case-image-upload v-model="fileLists.courseChat" :upload-id="uploadId('course-chat')" :active="innerVisible" />
          </el-form-item>
        </el-form>
      </el-tab-pane>

      <!-- 模块4 日语学习 -->
      <el-tab-pane label="日语学习" name="jap">
        <el-form label-width="100px" size="small">
          <el-form-item label="日语成绩1"><el-input v-model="ext.japScore1" placeholder="请输入日语成绩"></el-input></el-form-item>
          <el-form-item label="日语成绩2"><el-input v-model="ext.japScore2" placeholder="请输入日语成绩"></el-input></el-form-item>
          <el-form-item label="学习感受"><el-input type="textarea" :rows="3" v-model="ext.japStudyFeel" placeholder="请输入学习感受"></el-input></el-form-item>
          <el-form-item label="成绩截图">
            <case-image-upload v-model="fileLists.japScore" :upload-id="uploadId('jap-score')" :active="innerVisible" />
          </el-form-item>
          <el-form-item label="聊天记录">
            <case-image-upload v-model="fileLists.japChat" :upload-id="uploadId('jap-chat')" :active="innerVisible" />
          </el-form-item>
          <el-form-item label="其他文件">
            <case-file-upload v-model="fileLists.japOther" :upload-id="uploadId('jap-other')" :active="innerVisible" />
          </el-form-item>
        </el-form>
      </el-tab-pane>

      <!-- 模块5 私塾学习 -->
      <el-tab-pane label="私塾学习" name="private">
        <el-form label-width="100px" size="small">
          <el-form-item label="成绩1"><el-input v-model="ext.privateScore1" placeholder="请输入成绩"></el-input></el-form-item>
          <el-form-item label="成绩2"><el-input v-model="ext.privateScore2" placeholder="请输入成绩"></el-input></el-form-item>
          <el-form-item label="成绩3"><el-input v-model="ext.privateScore3" placeholder="请输入成绩"></el-input></el-form-item>
          <el-form-item label="学习感受"><el-input type="textarea" :rows="3" v-model="ext.privateStudyFeel" placeholder="请输入学习感受"></el-input></el-form-item>
          <el-form-item label="成绩4"><el-input v-model="ext.privateScore4" placeholder="请输入成绩"></el-input></el-form-item>
          <el-form-item label="校内考"><el-input v-model="ext.privateInternalExam" placeholder="请输入校内考"></el-input></el-form-item>
          <el-form-item label="成绩截图">
            <case-image-upload v-model="fileLists.privateScore" :upload-id="uploadId('private-score')" :active="innerVisible" />
          </el-form-item>
          <el-form-item label="聊天记录">
            <case-image-upload v-model="fileLists.privateChat" :upload-id="uploadId('private-chat')" :active="innerVisible" />
          </el-form-item>
        </el-form>
      </el-tab-pane>
    </el-tabs>
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" :loading="submiting" @click="saveAll">保存</el-button>
      <el-button @click="innerVisible = false">关闭</el-button>
    </span>
  </el-dialog>
</template>

<script>
import url from "@/plugins/urlHelper.js";
import caseOptions from "@/plugins/caseOptions.js";
import CaseImageUpload from "@/components/CaseImageUpload.vue";
import CaseFileUpload from "@/components/CaseFileUpload.vue";

const emptyExt = () => ({
  copySpecialCase: "", copyDifficulty: "", copyServiceFeel: "", courseFeel: "",
  japScore1: "", japScore2: "", japStudyFeel: "",
  privateScore1: "", privateScore2: "", privateScore3: "", privateScore4: "",
  privateInternalExam: "", privateStudyFeel: ""
});

export default {
  name: "StudentCaseDialog",
  components: { CaseImageUpload, CaseFileUpload },
  props: {
    visible: { type: Boolean, default: false },
    stuID: { type: Number, default: 0 }
  },
  data() {
    return {
      domain: url.getDomain(),
      innerVisible: false,
      activeTab: "apply",
      submiting: false,
      apply: { feel: "", book: "", bookPhoto: "" },
      ext: emptyExt(),
      fileLists: {
        applyChat: [], copyCase: [], copyMaterial: [],
        courseRemit: [], courseChat: [],
        japScore: [], japChat: [], japOther: [],
        privateScore: [], privateChat: []
      },
      uploadInited: false
    };
  },
  watch: {
    visible(val) {
      this.innerVisible = val;
    },
    innerVisible(val) {
      this.$emit("update:visible", val);
    }
  },
  methods: {
    uploadId(key) {
      return "case-up-" + key + "-" + (this.stuID || 0);
    },
    onClose() {
      this.uploadInited = false;
    },
    onOpened() {
      this.loadCase();
      this.$nextTick(() => this.initUploaders());
    },
    loadCase() {
      if (!this.stuID) return;
      var _this = this;
      $.get(url.getStu("getcase"), { stuID: this.stuID }, function(data) {
        if (!data) return;
        var a = data.apply || {};
        _this.apply.feel = a.feel || "";
        _this.apply.book = a.book || "";
        _this.apply.bookPhoto = a.bookPhoto || "";
        _this.fileLists.applyChat = _this.toFileItems(a.chatImgs);
        _this.ext = _this.mapExtFromServer(data.ext);
        _this.mapFilesFromServer(data.files || {});
      });
    },
    mapFilesFromServer(files) {
      var g = (mod, cat) => this.toFileItems((files[mod] && files[mod][cat]) || []);
      this.fileLists.copyCase = g("Copy", "CaseFile");
      this.fileLists.copyMaterial = g("Copy", "MaterialImg");
      this.fileLists.courseRemit = g("Course", "RemitImg");
      this.fileLists.courseChat = g("Course", "ChatImg");
      this.fileLists.japScore = g("JapStudy", "ScoreImg");
      this.fileLists.japChat = g("JapStudy", "ChatImg");
      this.fileLists.japOther = g("JapStudy", "OtherFile");
      this.fileLists.privateScore = g("PrivateStudy", "ScoreImg");
      this.fileLists.privateChat = g("PrivateStudy", "ChatImg");
    },
    toFileItems(list) {
      if (!list || !list.length) return [];
      return list.map(function(x) {
        return { filePath: x.filePath || "", fileName: x.fileName || "" };
      });
    },
    mapExtFromServer(row) {
      if (!row) return emptyExt();
      var ext = Object.assign(emptyExt(), row);
      // 历史三分字段合并到一个大框展示
      var parts = [ext.copySpecialCase, ext.copyDifficulty, ext.copyServiceFeel]
        .map(function (x) { return (x || "").trim(); })
        .filter(function (x) { return !!x; });
      if (parts.length > 1) {
        ext.copySpecialCase = parts.join("\n\n");
      } else if (parts.length === 1) {
        ext.copySpecialCase = parts[0];
      }
      ext.copyDifficulty = "";
      ext.copyServiceFeel = "";
      return ext;
    },
    initUploaders() {
      if (this.uploadInited) return;
      var _this = this;
      var mkSingleFile = function(elId, field, isImg) {
        var sel = "#" + elId;
        if ($(sel + " input").length > 0) return;
        $(sel).uploader({
          url: url.getUpload(),
          fileExts: isImg ? "jpg;png;jpeg" : "pdf;doc;docx",
          text: isImg ? "上传图片" : "上传文件",
          handleType: isImg ? "0" : "0",
          onSuccess: function(data) {
            _this.apply[field] = data.relativeName;
          }
        });
      };
      mkSingleFile(this.uploadId("apply-book"), "book", false);
      mkSingleFile(this.uploadId("apply-bookphoto"), "bookPhoto", true);
      this.uploadInited = true;
    },
    postFiles(moduleCode, fileCategory, list) {
      var paths = (list || []).map(function(x) { return x.filePath; }).join(",");
      var names = (list || []).map(function(x) { return x.fileName || ""; }).join(",");
      return $.post(url.getStu("savecase_files"), {
        stuID: this.stuID,
        moduleCode: moduleCode,
        fileCategory: fileCategory,
        filePaths: paths,
        fileNames: names
      });
    },
    saveApply() {
      var _this = this;
      return $.post(url.getStu("savecase_apply"), {
        stuID: _this.stuID,
        feel: _this.apply.feel,
        book: _this.apply.book,
        bookPhoto: _this.apply.bookPhoto
      }).then(function() {
        return _this.postFiles("Apply", "ChatImg", _this.fileLists.applyChat);
      });
    },
    saveExtAndFiles() {
      var _this = this;
      // 文案内容统一写入 CopySpecialCase，清空另外两列避免导出再散开
      var payload = Object.assign({ stuID: _this.stuID }, _this.ext, {
        copyDifficulty: "",
        copyServiceFeel: ""
      });
      return $.post(url.getStu("savecase_ext"), payload).then(function() {
        return $.when(
          _this.postFiles("Copy", "CaseFile", _this.fileLists.copyCase),
          _this.postFiles("Copy", "MaterialImg", _this.fileLists.copyMaterial),
          _this.postFiles("Course", "RemitImg", _this.fileLists.courseRemit),
          _this.postFiles("Course", "ChatImg", _this.fileLists.courseChat),
          _this.postFiles("JapStudy", "ScoreImg", _this.fileLists.japScore),
          _this.postFiles("JapStudy", "ChatImg", _this.fileLists.japChat),
          _this.postFiles("JapStudy", "OtherFile", _this.fileLists.japOther),
          _this.postFiles("PrivateStudy", "ScoreImg", _this.fileLists.privateScore),
          _this.postFiles("PrivateStudy", "ChatImg", _this.fileLists.privateChat)
        );
      });
    },
    saveAll() {
      var _this = this;
      _this.submiting = true;
      _this.saveApply()
        .then(function() { return _this.saveExtAndFiles(); })
        .done(function() {
          _this.submiting = false;
          _this.$message.success("保存成功");
          _this.$emit("saved");
        })
        .fail(function(xhr) {
          _this.submiting = false;
          var msg = (xhr.responseJSON && xhr.responseJSON.msg) || "保存失败";
          _this.$message.error(msg);
        });
    }
  }
};
</script>
